import { Alert, Card, Empty, Tag, Typography } from "antd";
import { useLeadershipAttentionQuery } from "../ReviewDetails/leadership.hooks";
import { formatLeadershipDate, getLeadershipStatusColor } from "../ReviewDetails/leadership.utils";
import DataState from "../../../components/DataState/DataState";


export default function LeadershipAttentionReadOnlyView({ projectId }) {
  const leadershipQuery = useLeadershipAttentionQuery(projectId);

  const leadershipItems = leadershipQuery.data?.items ?? [];

  // Loading on the first render of a new project and while a retry is in flight.
  const leadershipStatus =
    leadershipQuery.isLoading || (leadershipQuery.isError && leadershipQuery.isFetching)
      ? "loading"
      : leadershipQuery.isError
        ? "error"
        : "ready";
  const openCount = leadershipItems.filter((item) => {
    const normalizedStatus = String(item.status || "").trim().toLowerCase();
    return normalizedStatus !== "closed" && normalizedStatus !== "resolved";
  }).length;

  return (
    <DataState
      status={leadershipStatus}
      errorTitle="Couldn't load leadership attention items"
      error={leadershipQuery.error?.message || "Failed to fetch leadership attention items"}
      onRetry={() => leadershipQuery.refetch()}
      skeletonRows={4}
    >
    <Card
      style={{
        borderRadius: 14,
        border: "1px solid #f0f0f0",
      }}
      styles={{ body: { padding: 16 } }}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>Leadership Attention</span>
          <Tag
            color="orange"
            style={{
              borderRadius: 12,
              padding: "0 8px",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            {openCount} open
          </Tag>
        </div>
      }
    >
      <div style={{ maxHeight: 500, overflowY: "auto" }}>
        {/* {leadershipQuery.error && (
          <Alert type="error" message="Failed to load leadership attention items" showIcon style={{ marginBottom: 12 }} />
        )} */}


        {leadershipItems.length === 0 && (
          <Empty description="No leadership attention items yet" style={{ marginTop: 32 }} />
        )}

        {leadershipItems.length > 0 && (
          <div style={{ fontSize: 13, overflowX: "auto" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "30% 24% 14% 16% 16%",
                gap: 12,
                minWidth: 780,
                paddingBottom: 12,
                marginBottom: 12,
                borderBottom: "2px solid #f0f0f0",
                fontWeight: 600,
                fontSize: 12,
                color: "#595959",
                textTransform: "uppercase",
              }}
            >
              <div>Description</div>
              <div>Remarks</div>
              <div>Status</div>
              <div>Opened On</div>
              <div>Closed On</div>
            </div>

            {leadershipItems.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "30% 24% 14% 16% 16%",
                  gap: 12,
                  minWidth: 780,
                  paddingBottom: 12,
                  marginBottom: 12,
                  borderBottom: "1px solid #f0f0f0",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "4px 8px" }}>
                  <Typography.Text
                    style={{
                      fontSize: 13,
                      color: "#262626",
                      display: "block",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {item.description}
                  </Typography.Text>
                </div>

                <div style={{ padding: "4px 8px" }}>
                  <Typography.Text
                    style={{
                      fontSize: 12,
                      color: "#262626",
                      display: "block",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {item.remarks || "-"}
                  </Typography.Text>
                </div>

                <div style={{ padding: "4px 8px" }}>
                  <Tag color={getLeadershipStatusColor(item.status)} style={{ fontSize: 11, fontWeight: 600 }}>
                    {item.status || "Open"}
                  </Tag>
                </div>

                <div style={{ padding: "4px 8px" }}>
                  <Typography.Text style={{ fontSize: 12, color: "#262626" }}>
                    {formatLeadershipDate(item.openedOn)}
                  </Typography.Text>
                </div>

                <div style={{ padding: "4px 8px" }}>
                  <Typography.Text style={{ fontSize: 12, color: "#262626" }}>
                    {formatLeadershipDate(item.closedOn)}
                  </Typography.Text>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Card>
    </DataState>
  );
}
